<div class="component-container" *ngIf="powerStorageExists">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="margin-header-align section-heading text-uppercase">
      <div class="ui-g-12">
        <app-section-header
          [title]="'grid-comp.storage-title' | translate"
          [tooltip]="'tooltips.technical-data.storage' | translate"></app-section-header>
      </div>
      <div class="section-buttons">
        <lock-unlock-buttons
          [showLockButton]="isDetailsView"
          [showUnlockButton]="isDetailsView"
          [isLocked]="getSectionLocked()"
          [areButtonsDisabled]="!(isModeratorRole() && editabilityBasedOnProcessStatus.internalRoles)"
          (lockButtonClickedEvent)="lockSection()"
          (unLockButtonClickedEvent)="unlockSection()"></lock-unlock-buttons>
        <i
          *ngIf="isDetailsView"
          class="pi pi-comment"
          [ngClass]="isCommentVisible || getSectionComment() ? 'lock-icon-style' : 'unlock-icon-style'"
          [pTooltip]="showCommentTooltip() ? ('comment-section.comment-tooltip' | translate) : null"
          [tooltipPosition]="showCommentTooltip() ? 'bottom' : null"
          (click)="showComment()"></i>
      </div>
    </div>
  </div>
  <section-comment
    [isCommentTextInputVisible]="isModeratorRole() && (isCommentVisible || getSectionComment())"
    [isCommentTextVisible]="!isModeratorRole()"
    [isCommentSaveVisible]="!getSectionComment()"
    [isCommentDeleteButtonDisabled]="!editabilityBasedOnProcessStatus.internalRoles"
    [comment]="getSectionComment()"
    (saveCommentEvent)="updateComment($event)"
    (deleteCommentEvent)="deleteComment()"
    (changeTextEvent)="changeCommentText.emit($event)"></section-comment>
  <div [ngClass]="getSectionLocked() !== true || !applicationId ? '' : 'disable-section'">
    <div class="section-wrapper margin-align">
      <div class="section-column">
        <div class="section-field">
          <label class="ui-g-5">
            {{ 'grid-comp.storage-connection' | translate }}
          </label>
          <p-radioButton
            name="storage_connection"
            value="AC"
            label="{{ 'grid-comp.ac-gekoppelt' | translate }}"
            class="mr-2"
            [(ngModel)]="technicalData.storage_data.storage_connection"
            (ngModelChange)="storageConnectionChange($event)"
            #storage_connection="ngModel"
            required
            [pTooltip]="isEditableByExternalRoles() ? ('grid-comp.disabled-field-tooltip' | translate) : null"
            [tooltipPosition]="isEditableByExternalRoles() ? 'bottom' : null"
            [disabled]="isEditableByExternalRoles() || isSectionDisabled"></p-radioButton>
          <p-radioButton
            name="storage_connection"
            value="DC"
            [(ngModel)]="technicalData.storage_data.storage_connection"
            #storage_connection="ngModel"
            (ngModelChange)="storageConnectionChange($event)"
            label="{{ 'grid-comp.dc' | translate }}"
            required
            [pTooltip]="isEditableByExternalRoles() ? ('grid-comp.disabled-field-tooltip' | translate) : null"
            [tooltipPosition]="isEditableByExternalRoles() ? 'bottom' : null"
            [disabled]="isEditableByExternalRoles() || isSectionDisabled"></p-radioButton>
        </div>
        <div class="section-field">
          <label class="ui-g-5 required">
            {{ 'grid-comp.storage-connection-producer' | translate }}
          </label>
          <p-radioButton
            name="energy_producer_connection"
            value="AC"
            class="mr-2"
            label="{{ 'grid-comp.ac' | translate }}"
            [(ngModel)]="technicalData.storage_data.energy_producer_connection"
            #energy_producer_connection="ngModel"
            required
            [disabled]="isSectionDisabled"></p-radioButton>
          <p-radioButton
            name="energy_producer_connection"
            value="three-phase"
            label="{{ 'grid-comp.storage-three-phase' | translate }}"
            [(ngModel)]="technicalData.storage_data.energy_producer_connection"
            #energy_producer_connection="ngModel"
            required
            [disabled]="isSectionDisabled"></p-radioButton>
        </div>
        <div class="section-field" *ngIf="showPrimarySourcesRecordedSeparately">
          <label class="ui-g-5 required">
            {{ 'grid-comp.storage-sources-recorded-separately' | translate }}
          </label>
          <p-radioButton
            name="primary_sources_recorded_separately"
            value="true"
            class="mr-2"
            label="{{ 'grid-comp.yes' | translate }}"
            [(ngModel)]="technicalData.storage_data.primary_sources_recorded_separately"
            #primary_sources_recorded_separately="ngModel"
            required
            [disabled]="isSectionDisabled"></p-radioButton>
          <p-radioButton
            name="primary_sources_recorded_separately"
            value="false"
            label="{{ 'grid-comp.no' | translate }}"
            [(ngModel)]="technicalData.storage_data.primary_sources_recorded_separately"
            #primary_sources_recorded_separately="ngModel"
            required
            [disabled]="isSectionDisabled"></p-radioButton>
        </div>
        <div class="section-field" *ngIf="showFeedInPaymentsRecordedSeparately">
          <label class="ui-g-5 required">
            {{ 'grid-comp.storage-payments-recorded-correctly' | translate }}
          </label>
          <p-radioButton
            name="feed_in_payments_recorded_separately"
            value="true"
            class="mr-2"
            label="{{ 'grid-comp.yes' | translate }}"
            [(ngModel)]="technicalData.storage_data.feed_in_payments_recorded_separately"
            #feed_in_payments_recorded_separately="ngModel"
            required
            [disabled]="isSectionDisabled"></p-radioButton>
          <p-radioButton
            name="feed_in_payments_recorded_separately"
            value="false"
            [(ngModel)]="technicalData.storage_data.feed_in_payments_recorded_separately"
            label="{{ 'grid-comp.no' | translate }}"
            #feed_in_payments_recorded_separately="ngModel"
            required
            [disabled]="isSectionDisabled"></p-radioButton>
        </div>
        <div class="section-field">
          <label class="ui-g-5 required">
            {{ 'grid-comp.storage-no-grid-supplied' | translate }}
          </label>
          <p-radioButton
            name="energy_not_supplied_by_grid"
            value="true"
            class="mr-2"
            label="{{ 'grid-comp.yes' | translate }}"
            [(ngModel)]="technicalData.storage_data.energy_not_supplied_by_grid"
            #energy_not_supplied_by_grid="ngModel"
            required
            [disabled]="isSectionDisabled"></p-radioButton>
          <p-radioButton
            name="energy_not_supplied_by_grid"
            value="false"
            label="{{ 'grid-comp.no' | translate }}"
            [(ngModel)]="technicalData.storage_data.energy_not_supplied_by_grid"
            #energy_not_supplied_by_grid="ngModel"
            required
            [disabled]="isSectionDisabled"></p-radioButton>
        </div>
        <div class="section-field">
          <label class="ui-g-5 required">
            {{ 'grid-comp.storage-total-capacity' | translate }}
          </label>
          <p-inputNumber
            class="form-control"
            [(ngModel)]="technicalData.storage_data.total_capacity"
            name="totalStorageCapacity"
            #totalStorageCapacity="ngModel"
            mode="decimal"
            (ngModelChange)="calculatePowerDifference()"
            (keydown)="detectDecimalSeparator($event)"
            locale="de-DE"
            [minFractionDigits]="0"
            [maxFractionDigits]="3"
            required
            [disabled]="isSectionDisabled"></p-inputNumber>
          <label class="ml-2">kWh</label>
        </div>
        <div *ngIf="storagesPowerNotEqual" class="section-field">
          <i class="pi pi-exclamation-circle"></i>
          <span>{{ 'grid-comp.storage-warning' | translate }}</span>
        </div>
        <div class="section-field">
          <label class="ui-g-5 required">
            {{ 'grid-comp.max-discharge-capacity' | translate }}
          </label>
          <p-inputNumber
            class="form-control"
            [(ngModel)]="technicalData.storage_data.max_discharge_capacity"
            name="max_discharge_capacity"
            #max_discharge_capacity="ngModel"
            mode="decimal"
            (ngModelChange)="calculateMaximumDischargeCapacityDifference()"
            (keydown)="detectDecimalSeparator($event)"
            locale="de-DE"
            [minFractionDigits]="0"
            [maxFractionDigits]="3"
            required
            [disabled]="isSectionDisabled"></p-inputNumber>
          <label class="ml-2">kW</label>
        </div>
        <div *ngIf="maximumDischargeCapacityNotEqual" class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <i class="pi pi-exclamation-circle"></i>
          <span>{{ 'grid-comp.storage-max-discharge-capacity-warning' | translate }}</span>
        </div>
        <div *ngIf="showNumberOfCorrespondingFigureAccordingToFnn">
          <div class="section-field">
            <label class="ui-g-5 required">
              {{ 'grid-comp.storage-corresponding-figure' | translate }}
            </label>
            <input
              class="form-control"
              type="text"
              pInputText
              pattern="^\d+(\.\d+)*$"
              [(ngModel)]="technicalData.storage_data.number_of_corresponding_figure"
              name="number_of_corresponding_figure"
              #number_of_corresponding_figure="ngModel"
              required
              [disabled]="isSectionDisabled" />
          </div>
          <div class="section-field">
            <a
              href="https://www.lsw-netz.de/fileadmin/user_upload/lsw-netz/strom/antraege-formulare-vertraege/DB_Anschluss_und_Betrieb_von_Speichern_am_NS-Netz.pdf"
              target="_blank">
              Infolink FNN Hinweis
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="section-wrapper margin-align">
      <div *ngFor="let storage of technicalData.storages; index as i" class="top-bottom-margin bottom-border section-column">
        <div class="section-field inner-section-column">
          <label class="ui-g-12 font-bold">{{ 'grid-comp.storage-data' | translate }} {{ i + 1 }}</label>
        </div>
        <div class="section-field">
          <label class="ui-g-5 required">
            {{ 'grid-comp.manufacturer' | translate }}
          </label>
          <input
            class="form-control"
            type="text"
            pInputText
            [(ngModel)]="storage.manufacturer"
            name="storageManufacturer{{ i }}"
            #storageManufacturer{{i}}="ngModel"
            required
            [disabled]="isSectionDisabled" />
        </div>
        <div class="section-field">
          <label class="ui-g-5 required">
            {{ 'grid-comp.storage-usable-capacity' | translate }}
          </label>
          <p-inputNumber
            class="form-control"
            [(ngModel)]="storage.usable_capacity"
            name="usable_capacity{{ i }}"
            #usable_capacity{{i}}="ngModel"
            mode="decimal"
            (keydown)="detectDecimalSeparator($event)"
            locale="de-DE"
            [minFractionDigits]="0"
            (ngModelChange)="calculatePowerDifference()"
            [maxFractionDigits]="3"
            required
            [disabled]="isSectionDisabled"></p-inputNumber>
          <label class="ml-2">kWh</label>
        </div>
        <div class="section-field">
          <label class="ui-g-5 required">
            {{ 'grid-comp.storage-max-capacity' | translate }}
          </label>
          <p-inputNumber
            class="form-control"
            [(ngModel)]="storage.max_discharge_capacity"
            name="max_discharge_capacity{{ i }}"
            #max_discharge_capacity{{i}}="ngModel"
            mode="decimal"
            (keydown)="detectDecimalSeparator($event)"
            (ngModelChange)="calculateMaximumDischargeCapacityDifference()"
            locale="de-DE"
            [minFractionDigits]="0"
            [maxFractionDigits]="3"
            required
            [disabled]="isSectionDisabled"></p-inputNumber>
          <label class="ml-2">kW</label>
          <div
            *ngIf="i > 0"
            (click)="removeStorageUnit(storage)"
            class="pi pi-trash pointer-cursor right-aligned ui-g-2"
            [ngClass]="isSectionDisabled ? 'disable-section' : ''"></div>
        </div>
      </div>

      <div class="section-field" [ngClass]="isSectionDisabled ? 'disable-section' : ''">
        <i
          (click)="addStorageUnit()"
          class="pi pi-plus plus-icon margin-zero"
          data-testId="add-storage-button"
          tabindex="0"
          appEnterClick></i>
        <label class="ui-g-12 field-label">
          {{ 'grid-comp.add-storage' | translate }}
        </label>
      </div>
    </div>
    <div *ngIf="technicalData.storage_data.storage_connection === 'AC'" class="section-wrapper margin-align">
      <div *ngFor="let powerConverter of technicalData.power_converters; index as i" class="top-bottom-margin bottom-border">
        <app-eproducer-unit-form-element
          [energyUnit]="powerConverter"
          [index]="i"
          [isDetailsView]="isDetailsView"
          [isDisabled]="isSectionDisabled"
          [documents]="powerConverter.documents"
          [type]="UI_COLLECTION_TYPES.PowerConverter"
          (removeElementEvent)="removePowerConverter($event)"
          (clearFileEvent)="clearFile($event)"></app-eproducer-unit-form-element>
      </div>

      <div class="section-field" [ngClass]="isSectionDisabled ? 'disable-section' : ''">
        <i (click)="addPowerConverter()" class="pi pi-plus plus-icon margin-zero" tabindex="0" appEnterClick></i>
        <label class="ui-g-12 field-label">
          {{ 'grid-comp.add-converter' | translate }}
        </label>
      </div>
    </div>
  </div>
</div>
